module.exports = __webpack_public_path__ + "static/img/presysv20.eebd640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv20.png
// module id = 8YSG
// module chunks = 1